import { Component, ViewChild } from '@angular/core';
import { PowerBiReportViewerComponent } from '../../components/power-bi-report-viewer/power-bi-report-viewer.component';

@Component({
  selector: 'app-power-bi-report-page',
  templateUrl: './power-bi-report.component.html',
  styleUrls: ['./power-bi-report.component.scss'],
  standalone: false
})
export class PowerBiReportPageComponent {
  @ViewChild('reportViewer') reportViewer!: PowerBiReportViewerComponent;

  reportName = 'EOL Report';
  reportHeight = 'calc(100vh - 180px)';

  refreshReport(): void {
    if (this.reportViewer) {
      this.reportViewer.refresh();
    }
  }

  openInNewTab(): void {
    if (this.reportViewer) {
      this.reportViewer.openInNewTab();
    }
  }
}
